module.exports = __webpack_public_path__ + "img/xfz_quiz_night_creation.68417a80.png";